import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable , BehaviorSubject} from 'rxjs';
import { AppConfig } from '../../app.config';
@Injectable()
export class TargetGroupService  {
  targetGroup: any[];
  access;
  onAccessChanges: BehaviorSubject<any> = new BehaviorSubject({});
  onTargetGroupChanged: BehaviorSubject<any> = new BehaviorSubject({});
  constructor (private http: HttpClient, private api: AppConfig) {

  }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
  {

    return new Promise<void>((resolve, reject) => {

      Promise.all([
        this.getTargetGroups()
      ]).then(
        () => {
          resolve();
        },
        reject
      );
    });
  }

  getTargetGroups (withSettings = true) {
    return new Promise((resolve, reject) => {
      this.http.get(this.api.baseUrl + '/targetGroup/targetGroups?withSettings=' + withSettings  , this.api.jsonTokenHeaders)
        .subscribe((response: any) => {
          this.targetGroup = response.targetGroups;
          this.access = response.access;
          this.onTargetGroupChanged.next(this.targetGroup);
          this.onAccessChanges.next(this.access);
          resolve(response);
        }, reject);
    });

  }

  targetGroupsGroped(withSettings = true) {
    return this.http.get(this.api.baseUrl + '/targetGroup/targetGroupsGroped?withSettings=' + withSettings , this.api.jsonTokenHeaders);
  }

  getTargetGroupById(id) {
    return this.http.get(this.api.baseUrl + '/targetGroup/targetGroup?id=' + id , this.api.jsonTokenHeaders);
  }

  deleteTargetGroup(id) {
    return this.http.delete(this.api.baseUrl + '/targetGroup/deleteTargetGroup?id=' + id , this.api.jsonTokenHeaders);
  }

  addTargetGroup(data) {
    return this.http.post(this.api.baseUrl + '/targetGroup/addTargetGroup' , data , this.api.formDataHeaders);
  }
}
